import { render, staticRenderFns } from "./ToolsInsuranceTable.vue?vue&type=template&id=cf1db3a6&scoped=true"
import script from "./ToolsInsuranceTable.vue?vue&type=script&lang=js"
export * from "./ToolsInsuranceTable.vue?vue&type=script&lang=js"
import style0 from "./ToolsInsuranceTable.vue?vue&type=style&index=0&id=cf1db3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1db3a6",
  null
  
)

export default component.exports